import {ExcessProtectProposer} from './proposer.model';
import {Vehicle} from './vehicle.model';
import {Drivers} from './drivers.model';

export class ExcessProtect {
  id = '';
  broker_id = '';
  brokerComission: number = null;
  brokerAdminFee: number = null;
  company_id = '';
  reference = '';
  status = '';
  declaration: boolean = null;
  inception_date = '';
  proposer: any = new ExcessProtectProposer();
  ratingType = '';
  vehicles: any = [new Vehicle()];
  drivers: any = [new Drivers()];
  isReferred: boolean = null;
  policyId = '';
  effectiveDate = '';
  transactionalDate = '';
  oldPolicyId = '';
  discount = 0;
  type = 0;
  policyRefNumber: any;
  quoteMetaId: any;
  sequenceNumber: any;
  isSendEmail: any;
  data: { [key: string]: any};
  voluntaryExcess: any;
  commission: number;
  peliwica_fee: any;
  amlin_data: any;
  fleet_experiences: null;
  cover_to: any;
  excess_protect_cover_id:any;
}
